import { User } from '@supabase/supabase-js';
import { supabase } from './supabase';

// "I'm 18 or older" — asked at sign-up (see AgeConsent.tsx). The moment of
// confirmation is remembered here and saved on the account (user metadata
// `age_confirmed_at`) so there is a record of it.
const KEY = 'yhuu_age_confirmed_at';

export function markAgeConfirmed() {
  try { if (!localStorage.getItem(KEY)) localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ }
}

export function ageConfirmedAt(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

// Google sign-up leaves the site and comes back, so the confirmation can't be
// attached at sign-up time. Once they're back and signed in, save it on the account.
export async function recordAgeConfirmation(user: User) {
  try {
    const at = ageConfirmedAt();
    if (!at || user.user_metadata?.age_confirmed_at) return;
    await supabase.auth.updateUser({ data: { age_confirmed_at: at } });
  } catch { /* ignore */ }
}
